module.exports = __webpack_public_path__ + "img/average_body.3d88925f.svg";